module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "hero page-events"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container page-header"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v("Events")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n            Upcoming and past events.\n          ")])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "hero landing-rdj-events"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o"
  })]), _vm._v("Upcoming and past events")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n        Occasionally we host big events where your favorite big name artists bring you the newest tunes. Don't miss out on hearing the best of music and the opportunity to mingle with producers and DJs.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "src": require("../img/event-1.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "src": require("../img/event-2.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "src": require("../img/event-3.jpg")
    }
  })])]), _vm._v(" "), _c('br'), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09a5b6cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Events.vue
// module id = 166
// module chunks = 1